import { ISetPasswordRequest, IUpdateProfileRequest } from "./types";
import { baseProfileApi } from '@src/core/features';
import '@src/features/hubs/redux/api';

export const profileApi = baseProfileApi.injectEndpoints({
  endpoints: (builder) => ({
    updateProfile: builder.mutation<void, IUpdateProfileRequest>({
      query: (data) => ({
        url: '/api/v1/user/profile',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Profile'],
    }),
    setUserPassword: builder.mutation<void, ISetPasswordRequest>({
      query: (data) => ({
        url: '/api/v1/user/password',
        method: 'POST',
        data,
      })
    }),
    deleteMyAccount: builder.mutation<void, number>({
      query: (userId) => ({
        url: `/api/v1/user/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Profile'],
    }),
  })
});

export const { 
  useUpdateProfileMutation,
  useSetUserPasswordMutation,
  useDeleteMyAccountMutation,
} = profileApi;